"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var FormError_1 = __importDefault(require("../FormError"));
var SelectFieldSingleValue_1 = __importDefault(require("./SelectFieldSingleValue"));
var SelectFieldOptions_1 = __importDefault(require("./SelectFieldOptions"));
var fuzzyFilter_1 = __importDefault(require("./fuzzyFilter"));
var getDisplay = function (props) {
    var normal = props.value || props.values[props.name];
    var clearValueOnOpen = props.clearValueOnOpen;
    var display = props.initialDisplay || "";
    if (normal !== undefined) {
        if (props.allowEmpty) {
            return "" + normal;
        }
        var match = props.options.find(function (_a) {
            var value = _a.value;
            return value === normal;
        });
        if (match) {
            // This is because on the first load, I want to clean the value if you have a selected option
            display = clearValueOnOpen ? match.label : "";
        }
        else {
            display = normal;
        }
    }
    return display;
};
var SelectFieldSingle = /** @class */ (function (_super) {
    __extends(SelectFieldSingle, _super);
    function SelectFieldSingle(props) {
        var _this = _super.call(this, props) || this;
        _this.getValue = function () {
            var _a = _this.props, name = _a.name, value = _a.value, values = _a.values;
            if (value !== undefined) {
                return value;
            }
            var passed = values[name];
            if (passed !== undefined) {
                return passed;
            }
            return null;
        };
        _this.handleWindowClick = function (event) {
            var _a = _this.props, createClickNeeded = _a.createClickNeeded, onCloseAction = _a.onCloseAction, selectRef = _a.selectRef, isDestroyable = _a.isDestroyable;
            var _b = _this.state, open = _b.open, display = _b.display;
            var select = selectRef.current;
            if (open && select && event.target instanceof Element && !select.contains(event.target)) {
                if (createClickNeeded || display === "") {
                    var value = _this.getValue();
                    _this.selectValue(value);
                    _this.propagateValue(value);
                }
                else {
                    _this.selectValue(display);
                    _this.propagateValue(display);
                }
                if (onCloseAction) {
                    onCloseAction();
                }
            }
            else if (isDestroyable && !open) {
                _this.setState({ open: true });
            }
        };
        _this.handleSelect = function (selected) {
            var onFocus = _this.props.onFocus;
            onFocus();
            _this.selectValue(selected);
            _this.propagateValue(selected);
        };
        _this.handleDeselect = function () {
            var onFocus = _this.props.onFocus;
            onFocus();
            _this.selectValue(null);
            _this.propagateValue(null);
        };
        _this.handleChange = function (event) {
            var _a = _this.props, allWordsMatch = _a.allWordsMatch, options = _a.options, fixedValue = _a.fixedValue, onTextChanged = _a.onTextChanged;
            var display = _this.state.display;
            var normal = _this.getValue();
            var currentOption = (normal !== null && options.find(function (option) { return option.value === normal; }));
            var nextDisplay = event.target.value;
            nextDisplay = currentOption && currentOption.label === display
                ? event.nativeEvent.data
                : nextDisplay;
            if (onTextChanged) {
                onTextChanged(nextDisplay);
            }
            if (!fixedValue) {
                _this.setState({
                    display: nextDisplay || "",
                    filteredOptions: fuzzyFilter_1.default(options, nextDisplay, allWordsMatch),
                    open: true
                });
            }
        };
        _this.isAnOption = function (props) {
            var normal = props.value || props.values[props.name];
            if (normal !== undefined) {
                var match = props.options.find(function (_a) {
                    var value = _a.value;
                    return value === normal;
                });
                return !!match;
            }
            return false;
        };
        _this.handleOpen = function () {
            var onSelected = _this.props.onSelected;
            if (onSelected) {
                onSelected();
            }
            _this.setState({ open: true });
            var _a = _this.props, clearValueOnOpen = _a.clearValueOnOpen, fixedValue = _a.fixedValue;
            if (!fixedValue && clearValueOnOpen) {
                _this.setState({ display: "" });
            }
        };
        _this.handleClose = function () {
            _this.setState({ open: false, touched: true });
        };
        _this.propagateValue = function (value) {
            var _a = _this.props, name = _a.name, onChange = _a.onChange, onFormChange = _a.onFormChange;
            if (onChange) {
                onChange(value);
            }
            onFormChange(name, value);
        };
        _this.selectValue = function (nextValue) {
            var options = _this.props.options;
            var match = options.find(function (_a) {
                var value = _a.value;
                return value === nextValue;
            });
            var display = match ? match.label : (nextValue || "");
            _this.setState({ display: display, touched: true, open: false }, function () {
                if (_this.timeout) {
                    clearTimeout(_this.timeout);
                    _this.timeout = null;
                }
                _this.timeout = window.setTimeout(function () {
                    _this.setState({ filteredOptions: options });
                    _this.timeout = null;
                }, 150);
            });
        };
        _this.state = {
            display: getDisplay(props),
            filteredOptions: props.options,
            open: false,
            touched: false
        };
        _this.timeout = null;
        return _this;
    }
    SelectFieldSingle.prototype.componentDidMount = function () {
        window.addEventListener("click", this.handleWindowClick);
    };
    SelectFieldSingle.prototype.componentDidUpdate = function (prevProps) {
        var _this = this;
        var _a = this.props, allWordsMatch = _a.allWordsMatch, creatable = _a.creatable, options = _a.options, value = _a.value;
        var display = this.state.display;
        if (prevProps.options !== options) {
            this.setState(function (_a) {
                var open = _a.open;
                return ({
                    display: getDisplay(_this.props),
                    filteredOptions: open ? fuzzyFilter_1.default(options, display, allWordsMatch) : options
                });
            });
        }
        else if (prevProps.value !== value && (!creatable || !display)) {
            this.setState({ display: getDisplay(this.props) });
        }
    };
    SelectFieldSingle.prototype.componentWillUnmount = function () {
        window.removeEventListener("click", this.handleWindowClick);
        if (this.timeout) {
            clearTimeout(this.timeout);
            this.timeout = null;
        }
    };
    /* eslint-disable jsx-a11y/label-has-for */
    // we're following the rules for it but it can't figure that out
    SelectFieldSingle.prototype.render = function () {
        var _a = this.props, allowEmpty = _a.allowEmpty, ariaLabel = _a.ariaLabel, children = _a.children, childIsLabel = _a.childIsLabel, creatable = _a.creatable, creatableLabel = _a.creatableLabel, disabled = _a.disabled, fixedValue = _a.fixedValue, imageIconPath = _a.imageIconPath, inputRef = _a.inputRef, name = _a.name, onError = _a.onError, options = _a.options, placeholder = _a.placeholder, onCloseAction = _a.onCloseAction, onSelected = _a.onSelected, onUnselected = _a.onUnselected, required = _a.required, selectRef = _a.selectRef, submitted = _a.submitted, validator = _a.validator;
        var _b = this.state, display = _b.display, filteredOptions = _b.filteredOptions, open = _b.open, touched = _b.touched;
        var normal = this.getValue();
        var classes = imageIconPath ? "chq-ffd--sl chq-ffd--sl--with-icon" : "chq-ffd--sl";
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { ref: selectRef, className: classes },
                react_1.default.createElement(SelectFieldSingleValue_1.default, { ariaLabel: ariaLabel, childIsLabel: childIsLabel, disabled: disabled, display: display, fixedValue: fixedValue, imageIconPath: imageIconPath, inputRef: inputRef, name: name, onChange: this.handleChange, onClose: this.handleClose, onCloseAction: onCloseAction, onOpen: this.handleOpen, onSelected: onSelected, onUnselected: onUnselected, open: open, placeholder: placeholder, value: normal }),
                children,
                react_1.default.createElement(SelectFieldOptions_1.default, { allowEmpty: allowEmpty, creatable: creatable, creatableLabel: creatableLabel, display: display, filteredOptions: filteredOptions, multiple: false, onDeselect: this.handleDeselect, onSelect: this.handleSelect, open: open, options: options, value: normal })),
            react_1.default.createElement(FormError_1.default, { name: name, onError: onError, required: required, submitted: submitted, touched: touched, validator: validator, value: normal })));
    };
    return SelectFieldSingle;
}(react_1.default.Component));
exports.default = SelectFieldSingle;
